import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import yami1 from './assets/images/yami/yami1.jpg';
import yami2 from './assets/images/yami/yami2.jpg';
import yami3 from './assets/images/yami/yami3.jpg';
import yami4 from './assets/images/yami/yami4.jpg';
import yami5 from './assets/images/yami/yami5.jpg';
import yami6 from './assets/images/yami/yami6.jpg';
import yami7 from './assets/images/yami/yami7.jpg';
import yami8 from './assets/images/yami/yami8.jpg';
import yami9 from './assets/images/yami/yami9.jpg';
import yami10 from './assets/images/yami/yami10.jpg';
import yami11 from './assets/images/yami/yami11.jpg';
import yami12 from './assets/images/yami/yami12.jpg';
import yami13 from './assets/images/yami/yami13.jpg';
import yami14 from './assets/images/yami/yami14.jpg';
import yami15 from './assets/images/yami/yami15.jpg';
import yami16 from './assets/images/yami/yami16.jpg';
import yami17 from './assets/images/yami/yami17.jpg';
import yami18 from './assets/images/yami/yami18.jpg';


const photos = [
    { src: yami1, ...WidePhoto },
    { src: yami2, ...TallPhoto },
    { src: yami3, ...TallPhoto },
    { src: yami4, ...WidePhoto },
    { src: yami5, ...TallPhoto },
    { src: yami6, ...WidePhoto },
    { src: yami7, ...TallPhoto },
    { src: yami8, ...TallPhoto },
    { src: yami9, ...TallPhoto },
    { src: yami10, ...TallPhoto },
    { src: yami11, ...TallPhoto },
    { src: yami12, ...TallPhoto },
    { src: yami13, ...SquarePhoto },
    { src: yami14, ...TallPhoto },
    { src: yami15, ...TallPhoto },
    { src: yami16, ...TallPhoto },
    { src: yami17, ...WidePhoto },
    { src: yami18, ...WidePhoto },
];

const Yami = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="male">
                <i className="far fa-mars"></i>
                Yami
                <span className="stud">Available for Stud service to approved Bitches</span>
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>ch lunANOVA claircreek dark magic jwd AWD WWD</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA</td>
                        <td><span className="title">CKC Registration</span>#KC4157109</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>AM CH / MBIS MBPIS BPISS CAN GCH NORTHSKY DARKHORSE AT LUNANOVA JWD AWD WWD</td>
                        <td><span className="title">Dam</span>GCH CLAIRCREEK SHAKE It OFF</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>CURLY</td>
                        <td><span className="title">Coat Colour</span>BLACK</td>
                    </tr>
                    <tr>
                        <td><span className="title">CAER</span>NORMAL</td>
                        <td><span className="title">CDDY/IVVD</span>NORMAL</td>
                        <td><span className="title">EOPRA</span>NORMAL</td>
                    </tr>
                    <tr>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">Improper Coat</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                        <td><span className="title">MICROPHTHALMIA SYNDROME</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>GOOD (ELBOWS NORMAL)	</td>
                        <td><span className="title">PRA</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Yami;
